import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCreateExchangeRates = (params) => {
    return axios.post(`${backendHost}/api/admin/exchange-rates`, params);
};

export {
    postCreateExchangeRates
}